import { render, staticRenderFns } from "./CmsPreviewList.vue?vue&type=template&id=06973724&scoped=true"
import script from "./CmsPreviewList.vue?vue&type=script&lang=js"
export * from "./CmsPreviewList.vue?vue&type=script&lang=js"
import style0 from "./CmsPreviewList.vue?vue&type=style&index=0&id=06973724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06973724",
  null
  
)

export default component.exports